export const cookieNames = {
  token: 'LANDLORDACCESSSESSION',
  role: 'USERROLE',
  level: 'ACCOUNTLEVEL',
  landlordName: 'LANDLORDNAME',
  landlordContact: 'LANDLORDCONTACT',
  agentToken: 'AGENTACCESSSESSION',
  systemName: 'SYSTEMNAME',
};

export const storageNames = {
  paymentsetupProperties: 'PAYMENTSETUPPROPERTIES',
};
